import Vue from 'vue'

/**
 * インスタンス保持用
 */
let classInstance

/**
 * イベント用のインスタンス
 */
let vue = new Vue()

/**
 * ModalManager
 */
export default class ModalManager {
    /**
     * 自身のインスタンスを取得する.
     * @returns Api
     */
    static get instance() {
        if (!classInstance) {
            classInstance = new ModalManager()
        }
        return classInstance
    }

    /**
     * Vuejsへの登録 ※use時に呼び出される
     */
    static install() {
        Object.defineProperty(Vue.prototype, '$modalManager', {
            get() {
                return ModalManager.instance
            }
        })
    }

    /**
     * アカウント削除確認ダイアログ
     * 
     * @returns Promise
     */
    showDeleteConfirm() {
        return this.showModal('show-delete-confirm')
    }

    /**
     * アカウント削除完了
     * 
     * @returns Promise
     */
    showDeleteComplete() {
        return this.showModal('show-delete-complete')
    }

    /**
     * メール送信
     * 
     * @returns Promise
     */
    showSendMail() {
        return this.showModal('show-send-mail')
    }
    /**
     * メール再送信
     * 
     * @returns Promise
     */
    showReSendMail() {
        return this.showModal('show-resend-mail')
    }

    /**
     * パスワードリセット
     * 
     * @returns Promise
     */
    showResetPassword() {
        return this.showModal('show-reset-password')
    }

    /**
     * 電話番号変更
     * 
     * @returns Promise
     */
    showChangePhone() {
        return this.showModal('show-change-phone')
    }
    
    /**
     * SMSダイアログ
     * 
     * @returns Promise
     */
    showSmsMsg() {
        return this.showModal('show-sms-message')
    }

    /**
     * CSRFトークンエラー
     * 
     * @returns Promise
     */
    showCSRFErrMsg() {
        return this.showModal('show-csrf-error-message')
    }

    /**
     * メールアドレスの更新エラーダイアログ
     *
     * @returns Promise
     */
    showEmailErrMsg() {
        return this.showModal('show-email-error-message')
    }

    /**
     * ワンタイムコードのエラーダイアログ
     *
     * @returns Promise
     */
    showCodeErrMsg() {
        return this.showModal('show-code-error-message')
    }

    /**
     * Loading 多重送信防止
     * 
     * @returns Promise
     */
    showLoading() {
        return this.showModal('show-loading')
    }

    /**
     * モーダルを表示する.
     * 
     * @param {*} type 
     * @returns Promise
     */
    showModal(type) {
        return new Promise((resolve, reject) => {
            vue.$eventHub.$emit(type, {type: type, resolve: resolve, reject: reject})
        })
    }
}
